/**
 * The app's name, in one place. To try another name, change `parts` (and rebuild the web bundle): the first part is
 * drawn in the text color and the second in the accent red, as in the logo. Shared by the server, the ingest, the
 * web bundle and the tests. Not covered here (identifiers, not the name): the domain, the box's systemd units and
 * ~/monitusre paths, MONITUSRE_* env vars, localStorage keys, the iOS bundle id and the "monitus" WebKit handler.
 * The iOS app's display strings live in ios/MonitusRE/Sources/Brand.swift and ios/project.yml.
 */
const parts = ["House", "Vane"] as const;

export const BRAND = {
  parts,
  /** "HouseVane": titles, page text, metric categories ("{brand} Scores") */
  name: parts.join(""),
  /** "housevane": file names (CSV downloads) */
  slug: parts.join("").toLowerCase().replace(/[^a-z0-9]+/g, ""),
  /**
   * The promise under the name (the sidebar, the welcome card, the home page's title and <h1>, the video). True in
   * every state; what a deep state adds is its own line (shared/regions.ts `State.depth`).
   */
  tagline: "Charting the direction of your housing market",
} as const;
